import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/app/solutions/accounting/Accounting.jsx");
